import { getDeviceId } from './auth-utils';
import type { User } from '../types/user';
import { URL_PARAMS } from '../constants/urlParams';
import log from '../utils/logger';

// Configurazione base per tutte le chiamate Firebase Functions
export const FIREBASE_CONFIG = {
    model: "Browser",
    version: "1.2.0",
    prodID: "SNAI_WEB_CASINO",
    lan: "it",
} as const;

// Static language configuration
export const LANGUAGE_CONFIG = {
    currentLanguageCode: "it" // Can be changed to support multiple languages in the future
} as const;

// Funzione per ottenere il parametro tf
export const getTF = (): string => {
    // Leggo tipo_frontend direttamente dall'URL
    const urlParams = new URLSearchParams(window.location.search);
    const tipoFrontend = urlParams.get(URL_PARAMS.TIPO_FRONTEND);
    
    // Ritorna tipo_frontend se presente, altrimenti il valore di default
    return tipoFrontend || "84";
};

// Funzione per ottenere la configurazione con deviceID
export const getFirebaseConfig = () => {
    return {
        ...FIREBASE_CONFIG,
        tf: getTF(),
        deviceID: getDeviceId()
    };
};

// Function to replace URL parameters with user data
export const replaceUrlParameters = (url: string, user: User | null): string => {
    let processedUrl = url;
    
    if (user?.isLogged) {
        // Replace with actual user data
        processedUrl = processedUrl.replace(/\$token/g, user.token || '');
        processedUrl = processedUrl.replace(/\$carta/g, user.carta || '');
        processedUrl = processedUrl.replace(/\$username/g, user.user || '');
    } else {
        // Replace with empty strings if not logged in
        processedUrl = processedUrl.replace(/\$token/g, '');
        processedUrl = processedUrl.replace(/\$carta/g, '');
        processedUrl = processedUrl.replace(/\$username/g, '');
    }
    
    // Always replace language parameter with current language
    processedUrl = processedUrl.replace(/\$lan/g, LANGUAGE_CONFIG.currentLanguageCode);
    log.debug("processedUrl:", processedUrl)
    return processedUrl;
};

// NOTA: La generazione di requestId e sign è stata spostata in auth-utils.ts
// per seguire il pattern Swift con Remote Config e MD5

// Account sections constants
export const ACCOUNT_ITEM_IDS = {
    BONUS: 'bonus'
} as const;

// Balance refresh interval in seconds
export const BALANCE_REFRESH_INTERVAL = 300; // 300 seconds
export const LIVE_IMAGE_REFRESH_INTERVAL = 30; // 30 seconds